var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.6454L15.0128 16.6581C15.4686 17.114 16.2023 17.114 16.6581 16.6581C17.114 16.2023 17.114 15.4686 16.6581 15.0128L13.6454 12L16.6581 8.98722C17.114 8.53141 17.114 7.79767 16.6581 7.34186C16.2023 6.88605 15.4686 6.88605 15.0128 7.34186L12 10.3546L8.98722 7.34186C8.53141 6.88605 7.79766 6.88605 7.34186 7.34186C6.88605 7.79766 6.88605 8.53141 7.34186 8.98721L10.3546 12L7.34186 15.0128C6.88605 15.4686 6.88605 16.2023 7.34186 16.6581C7.79766 17.114 8.53141 17.114 8.98721 16.6581L12 13.6454Z",
    fill: "inhetir"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.48f216db.svg";
export { ForwardRef as ReactComponent };